import React__default from 'react';
import { Text } from './Text.js';
import './Divider.scss';

const Divider = ({ label }) => (React__default.createElement("div", { "data-rev-component": 'divider' }, label && (React__default.createElement(Text, { className: 'divider-label--rev', size: 'caption', inherit: true }, label))));
const OrDivider = () => React__default.createElement(Divider, { label: 'or' });

export { Divider, OrDivider };
//# sourceMappingURL=Divider.js.map
